class Unit {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allUnits: [],
      unit: new Unit(''),
      allUnitsForOther: [],
    };
  },
  methods: {
    getListOfUnits: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllUnits').then(() => {
        if (this.$store.state.unitModule.successFlag) {
          this.allUnitsForOther = this.$store.state.unitModule.allUnits;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.unitModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfUnits();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.unitModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfUnits();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllUnits: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllUnits').then(() => {
        if (this.$store.state.unitModule.successFlag) {
          this.allUnits = this.$store.state.unitModule.allUnits;
          this.allUnits.forEach((c) => (c.isEdit = false));
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.unitModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllUnits();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.unitModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllUnits();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addUnitFunction: function () {
      if (!this.unit.title) {
        this.snackText = 'عنوان واحد نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.unit.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان واحد نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addUnit', this.unit).then(() => {
        if (this.$store.state.unitModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.showAddEditModal = false;
          this.disabelConfirm = false;
          this.snackText = ' واحد با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.unit = new Unit('');
          this.getAllUnits();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.unitModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addUnitFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.unitModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addUnitFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getUnitFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getUnit', id).then(() => {
        if (this.$store.state.unitModule.successFlag) {
          this.unit = this.$store.state.unitModule.unit;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.unitModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getUnitFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.unitModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getUnitFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editUnitFunction: function () {
      if (!this.unit.title) {
        this.snackText = 'عنوان واحد نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.unit.title.replace(/\s/g, '').length) {
        this.snackText = 'عنوان واحد نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('editUnit', this.unit).then(() => {
        if (this.$store.state.unitModule.successFlag) {
          this.$refs.confirm.showConfirmDialog = false;
          this.disabelConfirm = false;
          this.showAddEditModal = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllUnits();
          this.snackText = ' واحد با موفقیت ویرایش شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.unit = new Unit('');
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.unitModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.editUnitFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.unitModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.editUnitFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    deleteUnitFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteUnit', this.unitId).then(() => {
        if (this.$store.state.unitModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getAllUnits();
          this.snackText = ' واحد با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.unitModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteUnitFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.unitModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteUnitFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    showError: function () {
      this.snackText = this.$store.state.unitModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
